<template lang="html">
  <div class="coupons">
    <div class="coupon-wrapper-hd">
      <ul class="coupon-tab">
        <li :class="{ active: tab === 1 }" @click="switchTab(1)">
          可用券<span v-show="available.length > 0"
            >({{ available.length }})</span
          >
        </li>
        <li :class="{ active: tab === 2 }" @click="switchTab(2)">
          不可用券<span v-show="unavailable.length > 0"
            >({{ unavailable.length }})</span
          >
        </li>
      </ul>
    </div>
    <div class="coupon-wrapper-bd">
      <div class="coupon-list">
        <ul>
          <li
            v-for="(item, index) in activeCoupons"
            :key="index"
            @click="selectCoupon(item)"
          >
            <div class="coupon-bd">
              <div class="coupon-main">
                <div
                  class="price"
                  :class="{
                    pink: item.couponType === 1,
                    yellow: item.couponType === 2,
                    blue: item.couponType === 3
                  }"
                >
                  <p>
                    <i>&yen;</i><strong>{{ item.couponAmount / 100 }}</strong>
                  </p>
                  <p v-if="item.couponType === 2">无门槛使用</p>
                  <p v-else>满&yen;{{ item.useAmountLimit / 100 }}使用</p>
                </div>
                <div class="title">
                  <p>{{ item.couponName }}</p>
                  <p>{{ item.couponDesc }}</p>
                </div>
              </div>
              <div class="coupon-time">
                <p v-if="tab === 1"></p>
                <p v-else @click.stop.prevent="showDesc(item)">
                  {{ item.couponDesc }}<i class="iconfont icon-tips"></i>
                </p>
                <p>
                  <time>{{ item.__startTime }}</time
                  >~<time>{{ item.__endTime }}</time>
                  <!-- <time
                    v-if="
                      item.useStartTime === `${item.useStartTimeStr} 00:00:00`
                    "
                    >{{ item.useStartTimeStr }}</time
                  ><time v-else>{{ item.useStartTime }}</time
                  >~<time
                    v-if="item.useEndTime === `${item.useEndTimeStr} 00:00:00`"
                    >{{ item.useEndTimeStr }}</time
                  ><time v-else>{{ item.useEndTime }}</time> -->
                </p>
              </div>
            </div>
            <div
              class="coupon-ft default-theme"
              :class="{
                'theme-pink': item.couponType === 1,
                'theme-yellow': item.couponType === 2,
                'theme-blue': item.couponType === 3
              }"
            >
              <span v-if="item.couponType === 2">现<br />金<br />券</span>
              <span v-else>满<br />减<br />券</span>
            </div>
          </li>
        </ul>
        <empty v-show="activeCoupons.length <= 0"></empty>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import fetch from '@/plugins/fetch'
import cookie from 'js-cookie'
import queryString from 'query-string'
import { Msgbox } from 'kf-component-vue'
import empty from './empty'

export default {
  data() {
    return {
      tab: 1
    }
  },
  computed: {
    ...mapState(['selectedCoupon', 'confirmCoupons']),
    available() {
      return this.confirmCoupons.usableList
    },
    unavailable() {
      return this.confirmCoupons.disableList
    },
    activeCoupons() {
      if (this.tab === 1) {
        this.setTime(this.available)
        return this.available || []
      } else {
        this.setTime(this.unavailable)
        return this.unavailable || []
      }
    }
  },
  methods: {
    setTime(list) {
      list.forEach(x => {
        if (x.useStartTime === `${x.useStartTimeStr} 00:00:00`) {
          x.__startTime = x.useStartTimeStr
        } else if (isFinite(x.useStartTime)) {
          x.__startTime = x.useStartTimeStr
        } else {
          x.__startTime = x.useStartTime
        }
        if (x.useEndTime === `${x.useEndTimeStr} 00:00:00`) {
          x.__endTime = x.useEndTimeStr
        } else if (isFinite(x.useEndTime)) {
          x.__endTime = x.useEndTimeStr
        } else {
          x.__endTime = x.useEndTime
        }
      })
    },
    switchTab(tab) {
      this.tab = tab
    },
    hostname(prefix = '') {
      const hn = location.hostname
      return hn.indexOf('haiziwang.com') > -1
        ? `//${prefix}.haiziwang.com`
        : `//${prefix}.cekid.com`
    },
    dateFormat(t, formater) {
      const time = new Date(t)
      const year = time.getFullYear()
      const month = `0${time.getMonth() + 1}`.slice(-2)
      const date = `0${time.getDate()}`.slice(-2)
      const hours = `0${time.getHours()}`.slice(-2)
      const minutes = `0${time.getMinutes()}`.slice(-2)
      const seconds = `0${time.getSeconds()}`.slice(-2)
      return formater
        .replace('YY', year)
        .replace('MM', month)
        .replace('DD', date)
        .replace('hh', hours)
        .replace('mm', minutes)
        .replace('ss', seconds)
    },
    selectCoupon(coupon) {
      if (this.tab === 2) {
        return
      }
      this.$emit('selectCoupon', coupon)
    },
    showDesc(coupon) {
      // .replace(/\n/g, '<br />')
      const desc = `<div class="coupon-desc">${coupon.couponDesc}</div>`
      Msgbox({
        title: '券适用范围',
        message: desc,
        confirmButtonText: '我知道了',
        confirmButtonClass: 'confirmButton',
        callback: action => {
          // if (action === 'confirm') {
          //     // 1
          // } else {
          //     // this.$$tracker('110701', '10000', 21062)
          // }
        }
      })
    }
  },
  components: {
    empty
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.coupons {
  min-height: 100%;

  .coupon-wrapper-hd {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .coupon-wrapper-bd {
    position: absolute;
    left: 0;
    // top: rem(180px);
    top: rem(80px);
    right: 0;
    bottom: 0;
    background: #f4f4f4;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .coupon-tab {
    display: flex;
    font-size: rem(28px);
    @include border(bottom);

    li {
      flex: 1;
      height: rem(80px);
      line-height: rem(80px);
      text-align: center;

      &.active {
        color: #ff397e;
        border-bottom: 1px solid #ff397e;
      }
    }
  }
  .coupon-search {
    display: flex;
    align-items: center;
    padding: rem(20px) rem(28px);
    font-size: rem(28px);

    .search-bd {
      flex: 1;
      margin-right: rem(32px);
    }
    input {
      width: 100%;
      padding-left: rem(28px);
      height: rem(60px);
      line-height: rem(60px);
      background: #f8f8f8;
      border-radius: rem(10px);
    }
    button {
      width: rem(173px);
      height: rem(60px);
      line-height: rem(60px);
      text-align: center;
      border: rem(2px) solid #444;
    }
  }
  .coupon-list {
    padding: rem(20px);
    font-size: rem(28px);

    li {
      display: flex;
      position: relative;
      margin-bottom: rem(20px);
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: rem(10px);
        height: 100%; //rem(220px);
        background: url('../../assets/images/coupon-grey-line.png') no-repeat;
        background-size: 100% 100%;
        z-index: 5;
      }
    }
    .coupon-bd {
      flex: 1;
      position: relative;
      padding: rem(20px) rem(30px) 0;
      background: #fff;
      border-right: none;

      &::after {
        content: '';
        width: 200%;
        height: 200%;
        position: absolute;
        top: 0;
        left: 0;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        box-sizing: border-box;
        pointer-events: none;
        z-index: 1;
      }
    }
    .coupon-ft {
      display: flex;
      align-items: center;
      justify-content: center;
      width: rem(70px);
      padding-left: rem(8px);
      background: #ff397e;
      color: #fff;
      line-height: 1.5;

      span {
        margin: auto;
      }

      &.default-theme {
        position: relative;

        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 0;
          height: 100%; // rem(220px);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          z-index: 5;
        }
        &::before {
          width: rem(16px);
          left: 0;
        }
        &::after {
          width: rem(10px);
          right: 0;
        }
      }
      &.theme-pink {
        background: #ff649b;

        &::before {
          background-image: url('../../assets/images/coupon-red-split.png');
        }
        &::after {
          background-image: url('../../assets/images/coupon-red-line.png');
        }
      }
      &.theme-yellow {
        background: #ffb637;
        &::before {
          background-image: url('../../assets/images/coupon-yellow-split.png');
        }
        &::after {
          background-image: url('../../assets/images/coupon-yellow-line.png');
        }
      }
      &.theme-blue {
        background: #53b0ff;
        &::before {
          background-image: url('../../assets/images/coupon-blue-split.png');
        }
        &::after {
          background-image: url('../../assets/images/coupon-blue-line.png');
        }
      }
    }
    .coupon-main {
      display: flex;
      padding-bottom: rem(25px);
      .price {
        min-width: rem(190px);
        font-size: rem(22px);
        margin-right: rem(20px);

        i {
          display: inline-block;
          margin-top: rem(10px);
          vertical-align: top;
          font-size: rem(32px);
          margin-right: rem(10px);
        }
        strong {
          font-size: rem(80px);
          font-weight: 400;
        }
        > p:first-of-type {
          // color: #ff397e
        }
        > p:last-of-type {
          color: #666;
          margin-top: rem(15px);
        }

        &.pink {
          color: #ff397e;
        }
        &.yellow {
          color: #ffb637;
        }
        &.blue {
          color: #53b0ff;
        }
      }
      .title {
        flex: 1;
        margin-top: rem(10px);
        > p:first-of-type {
          display: block;
          word-break: break-all;
          text-align: left;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          display: -webkit-box;
          overflow: hidden;
          font-size: rem(32px);
          height: rem(35px);
          line-height: 1.2;

          em {
            margin-left: rem(10px);
            color: #a947ff;
            font-size: rem(24px);
          }
        }
        > p:last-of-type {
          margin-top: rem(10px);
          display: block;
          word-break: break-all;
          text-align: left;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          display: -webkit-box;
          height: 2.7em;
          line-height: 1.4;
          overflow: hidden;
          font-size: rem(24px);
          color: #999;
        }
      }
    }
    .coupon-time {
      display: flex;
      align-items: center;
      padding: rem(15px) 0;
      font-size: rem(22px);
      color: #999;
      @include border(top, #e8e8e8, 1px, 0, dashed);

      > p:first-child {
        flex: 1;

        .icon-tips {
          margin-left: rem(10px);
          font-size: rem(22px);
        }
      }
      time {
        font-size: rem(24px);
      }
    }
  }
}
</style>
<style>
.coupon-desc {
  color: #333;
  line-height: 1.5;
  white-space: pre-line;
  text-align: left;
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 15px;
}
.confirmButton.confirmButton {
  color: #ff397e;
  font-size: 15px;
}
</style>
